module.exports = __webpack_public_path__ + "img/prefeitura.2e93cc18.jpeg";